
export enum SessionCancelStatus { 
    pending = 0,
    cancelled = 1
}

